
import Vue from 'vue'
import { mapState } from 'vuex'

export default Vue.extend({
  props: {
    type: String,
    is_active: Boolean,
  },

  data() {
    return this.$store.getters.button(this.type)
  },
})
